export const validUrl = (url: string) => /^(https*|www\.)/gi.test(url);

export const redirect = (url: string) => {
  if (validUrl(url)) {
    window.location.href = url;
  } else {
    if (url) {
      if (url?.[0] === "/") {
        window.location.href = `${url}`;
      } else {
        window.location.href = `/${url}`;
      }
    } else {
      window.location.href = "/";
    }
  }
};

const defaultImg =
  "data:image/png;base64,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";
export const getImgUrl = (url: string) =>
  url
    ? validUrl(url)
      ? url
      : `${process.env.REACT_APP_ASSETS}${url}`
    : defaultImg;

export const getPage = (query: string) => {
  const page = new URLSearchParams(query || window.location.search);
  return parseInt(page.get("page") as any);
};

export const getParamValue = (query?: string, field?: string) => {
  const page = new URLSearchParams(query || window.location.search);
  return field ? page.get(field) : page.getAll(field as any);
};

// get url query values
export const getQueryParams = () => {
  //legacy
  const obj = window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r: any, e: any) =>
        e
          ? ((r[e.split("=")[0]] = decodeURIComponent(e.split("=")[1])), r)
          : undefined,
      {}
    );
  return (obj && Object.keys(obj)?.length && obj) || {};
};

export const getUpdatedUrl = (key?: string, value?: any) => {
  // legacy, below is more dynamic
  const obj = window.location.search
    .replace("?", "")
    .split("&")
    .reduce((r: any, e: any): any => {
      return {
        [e.split("=")[0]]: encodeURIComponent(e.split("=")[1]),
      };
    }, {});

  const newObj = [];
  for (const [key2, value2] of Object.entries(obj)) {
    if (key2 && value2 && key2 !== key) {
      newObj.push({
        [key2]: value2,
      });
    }
  }
  if (key) {
    newObj.push({ [key]: value });
  }

  let str = "";
  for (const [key, value] of Object.entries(newObj)) {
    str += Object?.keys(value)?.[0] + "=" + Object.values(value)?.[0] + "&";
  }
  const newUrl = `${window.location.pathname}?${str.slice(0, str?.length - 1)}`;

  // console.log("formed: ", obj, newObj, newUrl);

  return newUrl;
};

export const jcTypeArray = [
  "JC_MALL",
  "JC_GROCERY",
  "JC_COMMERCE",
  "JC_GLOBAL",
  "JC_MART",
  "JC_FOOD",
  // "JC_FASHION",
  // "JC_MEDICINE",
  // "JC_PARCEL",
];


export const instituteArray = [
  "JC_MALL",
  "JC_GROCERY",
  "JC_COMMERCE",
  "JC_GLOBAL",
  "JC_MART",
  "JC_FOOD",
];

export const TopUpStatusTypeArray = [
  "PENDING",
  "APPROVED",
  "REJECTED",
];

export const OrderTypeArray = [
  "PENDING",
  "INITIATED",
  "CONFIRMED_BY_CS",
  "REQUESTED_TO_MERCHANT",
  "REQUESTED_TO_DM",
  "PROCESSING",
  "ACCEPTED_BY_MERCHANT",
  "ACCEPTED_BY_DELIVERY_MAN",
  "READY_TO_PICKUP",
  "ON_DELIVERY",
  "PICKED",
  "DELIVERED",
  "COMPLETED",
  "REVIEWED",
  "ALREADY_REVIEWED",
  "CANCELLED",
];

export const imageOrderStatus = ["INITIATED", "PROCESSING"];

export const MerchantOrderTypeArray = [
  "INITIATED",
  "REQUESTED_TO_MERCHANT",
  "ACCEPTED_BY_MERCHANT",
  "READY_TO_PICKUP",
  "CANCELLED",
];

export const DmOrderTypeArray = [
  "INITIATED",
  "REQUESTED_TO_DM",
  "ACCEPTED_BY_DELIVERY_MAN",
  "PICKED",
  "DELIVERED",
  "COMPLETED",
  "REVIEWED",
  "ALREADY_REVIEWED",
  "CANCELLED",
];

export const MerchantStatus = [
  "WAITING_FOR_PERSONAL_DETAILS",
  "WAITING_FOR_BANK_INFO",
  "WAITING_FOR_STORE_INFO",
  "WAITING_FOR_WAREHOUSE_INFO",
  "WAITING_FOR_VERIFICATION",
  "VERIFIED",
];

export const priceCalculationType = [
  "SHOP_BASED_COMMISSION",
  "CATEGORY_BASED_COMMISSION",
  "TP_BASED_COMMISSION",
];

export const mobileOperatorType = ["GP", "BL", "Airtel", "Teletalk", "Robi"];
export const simOperatorType = ["Prepaid", "Postpaid"];

export const MerchantProductStatus = ["APPROVED", "REJECTED", "REQUESTED"];
export const ProductStatus = ["WAITING_FOR_APPROVAL", "APPROVED", "REJECTED"];
export const ShopStatus = ["Open", "Close", "Busy"];
export const CampaignProductStatus = [
  "APPROVED",
  "REJECTED",
  "WAITING_FOR_APPROVAL",
];

export const DriverStatus = [
  "VERIFIED",
  "PENDING",
  "SUSPEND",
  "WAITING_FOR_VERIFICATION",
];

export const promoUsedForArray = [
  "ALL_PRODUCTS",
  "NON_DISCOUNTED_PRODUCTS",
  "NON_EXCLUDED_PRODUCTS",
];

export const checkStatesAndPushToHistory = (
  previousStates,
  currentStates,
  stateNames,
  navigate
) => {
  let shouldResetPage = false;
  for (let i = 0; i < previousStates.length; i++) {
    if (previousStates[i] != currentStates[i]) {
      shouldResetPage = true;
      navigate(getUpdatedUrl(stateNames[i], `${currentStates[i]}`));
    }
  }
  if (shouldResetPage) {
    navigate(getUpdatedUrl("page", `${0}`));
  }

  return shouldResetPage;
};
